import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import PreampGuts from './assets/IMG_0321.jpg';
import analogStageGuts from './assets/IMG_0722_VSCO.JPG';
import Shop from "./Shop";
import Videos from "./Videos";
import Contact from "./Contact";
import asPedalGuts from './assets/asPedalGuts.JPG';

function Home(props) {
  const [photo, setPhoto] = useState(analogStageGuts);

//   let count = 0;
// const myInterval = window.setInterval(() => {
//   count++;
//   console.log(`Timer tick: ${count}`);
//   if (count > 20) {
//     count = 0;
//   }
// }, 1000); // Executes every 1000ms (1 second)






    return (
    <div>
      <div style={{
        height: '400px',
        backgroundImage: `url(${photo}`,
        backgroundSize: '100vw',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center', 
        marginTop: '10px'
      }}>
        {/* Optional overlay content */}
        {/* <h1 style={{ color: 'white', fontSize: '3rem' }}>Welcome</h1> */}
      </div>
      <div ref={props.shopRef}>
      <Shop products = {props.products}/>
      </div>
      <div ref={props.videosRef}>
      <Videos/>
      </div>
      <div ref={props.contactRef}>
      <Contact/>
      </div>
      </div>
    );
  }

export default Home;